import {Component, OnInit} from 'ng-metadata/core';
import {StackMapService} from './stackMap.service';
import {Component,Inject, Input,Output, EventEmitter} from 'ng-metadata/core';

@Component({
    selector: 'prm-stack-map',
    templateUrl: 'components/search/fullView/getit/opac/locations/stackMap/stack-map.html',
})

export class PrmStackMap implements OnInit {
    @Input() private mapUrl;

    constructor(private stackMapService: StackMapService, @Inject('opacLocations') private opacLocations) {
    }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/stackMap/stackMap.directive.ts